module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layui-tab-brief",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px",
      "line-height": "30px",
      "float": "left"
    }
  }, [_vm._v("粘贴图片或上传图片即可")]), _vm._v(" "), _c('v-upload', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "beforeShow": true,
      "uploadApi": '/static/data/editorUpload.json'
    },
    on: {
      "before": _vm.toBase64
    }
  }, [_c('v-button', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_vm._v("\n          选择图片\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previewBase64),
      expression: "previewBase64"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "Base64图片"
    },
    domProps: {
      "value": (_vm.previewBase64)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.previewBase64 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [(_vm.previewBase64) ? _c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": _vm.previewBase64
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32d9e85f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tobase64.vue
// module id = 316
// module chunks = 2